import { render, staticRenderFns } from "./UploadFileTable.vue?vue&type=template&id=063a7f79&scoped=true"
import script from "./UploadFileTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFileTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UploadFileTable.vue?vue&type=style&index=0&id=063a7f79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a7f79",
  null
  
)

export default component.exports